<!-- Start Header Area -->
<header class="header-area p-relative">
    <div class="top-header top-header-style-three">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <ul class="top-header-contact-info">
                        <li>
                            {{call}}:
                            <a href="tel:502464674">{{setting.phone}}</a>
                        </li>
                    </ul>

                    <div class="top-header-social">
                        <span>{{followUs}}:</span>
                        <a href="{{setting.facebookLink}}" target="_blank"><i class='bx bxl-facebook'></i></a>
                        <a href="{{setting.youtubeLink}}" target="_blank"><i class='bx bxl-youtube'></i></a>
                        <a href="{{setting.linkedInLink}}" target="_blank"><i class='bx bxl-linkedin'></i></a>
                        <a href="{{setting.telegramLink}}" target="_blank"><i class='bx bxl-telegram'></i></a>
                        <a href="{{setting.tiktokLink}}" target="_blank">
                            <i>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="currentColor" d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74a2.89 2.89 0 0 1 2.31-4.64a2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/></svg>
                            </i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4" *ngIf="isCheckedAuth;">
                    <ul class="top-header-login-register" *ngIf="isLoggedIn; else elseBlock">

      
                
                        <li><a href="javascript:;" (click)="goMyAccount()"><i class='bx bxs-user'></i> {{myAccount}}</a>

                        </li>
                        <li id="language-mobile">
                            <a href="javascript:;" (click)="onSwitchLanguage()"> <img src="{{flagImage}}" class="shadow"
                                    alt="image"></a>
                        </li>
                    </ul>
                    <ng-template #elseBlock>
                        <ul  class="top-header-login-register">
                            <li><a [routerLink]="['/login']"><i class='bx bx-log-in'></i> {{login}}</a></li>
                            <li><a [routerLink]="['/register']"><i class='bx bx-log-in-circle'></i> {{register}}</a>
                            </li>
                            <li id="language-mobile">
                                <a href="javascript:;" (click)="onSwitchLanguage()"> <img src="{{flagImage}}"
                                        class="shadow" alt="image"></a>
                            </li>
                        </ul>
                    </ng-template>
                </div>

            </div>
        </div>
    </div>

    <app-navbar [isHome]=true></app-navbar>


</header>
<!-- End Header Area -->
<router-outlet (activate)="onActivate($event)"></router-outlet>
<app-footer [setting]="setting"></app-footer>